// extracted by mini-css-extract-plugin
module.exports = {"content":"Obras_content__2o3AI","box":"Obras_box__vJcT2","texto":"Obras_texto__2ZXVM","image":"Obras_image__2O-JT"};